// @flow

// Types
type FetchRequest = {
  url: string,
  method: string,
  options: Object,
}

// Constants
const DEFAULT_REQUEST = {
  url: 'UNKNOWN',
  method: 'GET',
  options: {},
}

/**
 * Custom Mozio API Error for the SDK.
 * @param {string} message HTTP API Error message
 * @param {number} errorCode API Error code
 * @param {number} status HTTP Status code
 * @returns {void}
 */
class APIError extends Error {
  errorCode: number | string

  status: number

  request: FetchRequest

  response: Object

  constructor(
    message: string,
    errorCode: number | string,
    status?: number,
    request?: ?FetchRequest,
    response?: Object
  ) {
    super(message)
    this.status = status || 500
    this.request = request || DEFAULT_REQUEST
    this.response = response || {}
    this.errorCode = errorCode
    this.message = message
    this.name = 'APIError'
  }
}

export default APIError
